// _components/site-header.js
import { LitElement, html, css, unsafeCSS } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { classMap } from 'lit/directives/class-map.js';

const tailwindStyles = css`${unsafeCSS(COMPONENT_STYLES)}`;

class SiteHeader extends LitElement {
  static properties = {
    sitePath: { type: String },
    pageUrl: { type: String },
  };

  static styles = tailwindStyles;

  constructor() {
    super();
    this.sitePath = '/';
    this.pageUrl = '/';
    this.waitlist = '/#cta-footer';
  }

  render() {
    const navLinkClasses = {
      'text-sm': true, 'font-medium': true, 'text-slate-600': true, 'hover:text-dash-blue': true, 'transition-colors': true,
      'text-dash-blue': this.pageUrl.includes('/docs'),
    };

    return html`
      <header class="sticky top-0 z-50 w-full border-b border-slate-200 bg-white/80 backdrop-blur-md">
        <div class="container flex h-16 items-center justify-between px-4 md:px-8">
          <a class="flex items-center gap-2" href="/">
            <div class="h-8 w-8 rounded-full bg-dash-blue flex items-center justify-center text-white font-bold">D</div>
            <span class="text-xl font-bold tracking-tight text-slate-900">DashReply</span>
          </a>
          
          <nav class="hidden md:flex items-center gap-8">
             <!-- <a class="${classMap(navLinkClasses)}" href="/docs">Docs</a> -->
          </nav>

          <div class="flex items-center gap-4">
            <a 
              href="${this.waitlist}" 
              target="_self"
              class="inline-flex h-10 items-center justify-center rounded-full bg-dash-blue px-6 text-sm font-semibold text-white shadow-lg shadow-blue-500/20 transition-all hover:bg-blue-600 hover:scale-105 hover:shadow-blue-500/40 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2"
            >
              Join Waitlist
            </a>
          </div>
        </div>
      </header>
    `;
  }
}

customElements.define('site-header', SiteHeader);